import React from "react";

import * as dateish from "js/dateish";
import { useSelector } from "react-redux";

import { getBarchartValue, type Barchart } from "js/ebird/barcharts";
import TaxonLink from "web/ui/taxon_link";
import { useTaxonomy } from "web/hooks";
import { getObservationsDateish, getRegionalBarchart } from "web/app_slice";
import type { RootState } from "web/store";

const NeedsList = ({ date }: { date: dateish.Any }) => {
  const taxonomy = useTaxonomy();
  const barchart = useSelector(getRegionalBarchart)!;
  const observations = useSelector((state: RootState) => getObservationsDateish(state, date));

  const rows = barchart.dataRows
    .filter(r => r.taxon?.category === 'species')
    .map(r => (
      { taxon: taxonomy.code(r.speciesCode), value: getBarchartValue(r, date) }
    ))
    .filter(({ value }) => value > 0)
    // TODO: Faster way to do this filter
    .filter(({ taxon }) => !observations.find(o => o.taxon.speciesCode === taxon.taxonCode!));

  rows.sort((b,a) => a.value - b.value || a.taxon.sort - b.taxon.sort);

  return <div>
    <table>
    { rows.map(({ taxon, value }) => (
      <tr key={ taxon.taxonCode }>
        <td><TaxonLink taxon={ taxon } /></td>
        <td>{ (value * 100).toFixed(2) }%</td>
      </tr>
    )) }
    </table>
  </div>
}

export default NeedsList;
